import { createContext } from "react";

const ModalContext = createContext('modal');

export default ModalContext;